var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"376px"}},[_c('v-card-title',{staticClass:"secondary--text"},[_vm._v(" "+_vm._s(_vm.$t('title.upcomingReservations'))+" ")]),_c('v-virtual-scroll',{attrs:{"height":376 - 64,"items":_vm.items,"item-height":"78"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('upcoming-reservation',{attrs:{"from":_vm.from,"index":item}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }